import { Row, Col, Form, Button } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import Select from "react-select"
import { atualizarProdutos } from "./InsumosLocalSlice"

export default function ProdutosLista({ local, produtosDados, produtoOptions, unidadesDados, unidadeOptions }: iProps) {

    const dispatch = useDispatch()
    const produtos: any[] = useSelector((state: any) => state.uiInsumosLocal.produtos)

    function handleChange(idx: number, coluna: "qtd" | "prod" | "unid", value: any) {
        if (idx > produtos.length) {
            return
        }
        let produtosAux: any[] = []
        for (let id in produtos) {
            let produto = {
                id: produtos[id].id,
                id_local: produtos[id].id_local,
                id_produto: produtos[id].id_produto,
                id_unidade: produtos[id].id_unidade,
                qtd: produtos[id].qtd,
            }
            if (Number(id) === idx) {
                switch (coluna) {
                    case "qtd":
                        produto["qtd"] = Number(value)
                        break;
                    case "prod":
                        const ID_PRODUTO = Number(value)
                        produto["id_produto"] = ID_PRODUTO
                        const produtosEncontrados = produtosDados.filter(reg => reg.id_produto === ID_PRODUTO)
                        if (produtosEncontrados.length > 0) { produto["id_unidade"] = produtosEncontrados[0].id_unidade_padrao.id_unidade }
                        break;
                    case "unid":
                        produto["id_unidade"] = Number(value)
                        break;
                }
            }
            produtosAux.push(produto)
        }
        dispatch(atualizarProdutos({ produtos: produtosAux }))
    }

    function handleAdd(event: any) {
        let produto_novo = {
            id: null,
            id_local: Object.values(local).length === 0 ? null : local.id_local,
            id_produto: 0,
            id_unidade: 0,
            qtd: 1,
        }
        let localProdutosAux: any[] = []
        for (let reg of produtos) { localProdutosAux.push(reg) }
        localProdutosAux.push(produto_novo)
        dispatch(atualizarProdutos({ produtos: localProdutosAux }))
    }

    function getLabel(option: "prod" | "unid", id: number): string {
        let options = []
        if (option === "prod") {
            options = produtoOptions.filter(reg => Number(reg.value) === id)
        }
        if (option === "unid") {
            options = unidadeOptions.filter(reg => Number(reg.value) === id)
        }
        if (options.length > 0) {
            return options[0].label
        }
        return `${option}-${id}`
    }

    function handleRemove(idx: number) {
        let localProdutosAux: any[] = []
        for (let id in produtos) {
            if (Number(id) === idx) {
                continue
            }
            localProdutosAux.push(produtos[id])
        }
        dispatch(atualizarProdutos({ produtos: localProdutosAux }))
    }

    return (
        <div>
            {
                produtos.length === 0 &&
                <p>Não há itens na lista.</p>
            }
            {
                produtos.map((prod, idx, arr) => {
                    const defaultValue = { value: 0, label: "Não Selecionado" }
                    let qtd = prod.qtd === 0 ? 1 : prod.qtd
                    let produto = prod.id_produto === 0 ? defaultValue : { value: prod.id_produto, label: getLabel("prod", prod.id_produto) }
                    let unidade = prod.id_unidade === 0 ? defaultValue : { value: prod.id_unidade, label: getLabel("unid", prod.id_unidade) }
                    return (
                        <div key={idx}>
                            <Row className="mb-15-forms">
                                <Col className="col-1">
                                    <Form.Group>
                                        { idx === 0 && <Form.Label>Quantidade:</Form.Label> }
                                        <Form.Control name={`${idx}-qtd`} type="number" id={`${idx}-qtd`} placeholder="" value={qtd} onChange={
                                            (event) => {
                                                handleChange(idx, "qtd", event.target.value)
                                            }
                                        } />
                                        <Form.Control.Feedback type="invalid">
                                            Informe a quantidade!
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col className="col-1">
                                    <Form.Group style={{ width: "100%" }}>
                                        { idx === 0 && <Form.Label>Unidade:</Form.Label> }
                                        <Select name='id_unidade' id='id_unidade' options={unidadeOptions} value={unidade} placeholder="Selecione" onChange={
                                            (choice: any) => {
                                                handleChange(idx, "unid", choice.value)
                                            }
                                        } styles={customStyleSelect} />
                                        <Form.Control name={`${idx}-id_unidade_aux`} type="text" id={`${idx}-id_unidade_aux`} placeholder="" style={{ display: "none" }} />
                                        <Form.Control.Feedback type="invalid">
                                            Informe a Unidade!
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col className='col-5'>
                                    <Form.Group style={{ width: "100%" }}>
                                        { idx === 0 && <Form.Label>Produto:</Form.Label> }
                                        <Select name={`${idx}-id_produto`} id={`${idx}-id_produto`} options={produtoOptions} value={produto} placeholder="Selecione" onChange={
                                            (choice: any) => {
                                                handleChange(idx, "prod", choice.value)
                                            }
                                        } styles={customStyleSelect} />
                                        <Form.Control name={`${idx}-id_produto_aux`} type="text" id={`${idx}-id_produto_aux`} placeholder="" style={{ display: "none" }} />
                                        <Form.Control.Feedback type="invalid">
                                            Informe o Produto!
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col className="col-1">
                                    { idx === 0 && <div><Form.Label>&nbsp;</Form.Label><br></br></div> }
                                    <Button variant="secondary" onClick={() => handleRemove(idx)} >Remover</Button>
                                </Col>
                                {
                                    idx === (produtos.length - 1) &&
                                    <Col className="col-2">
                                        { idx === 0 && <div><Form.Label>&nbsp;</Form.Label><br></br></div> }
                                        <Button variant="primary" onClick={handleAdd} >Adicionar Produto</Button>
                                    </Col>
                                }
                            </Row>
                        </div>
                    )
                })
            }
            {
                produtos.length === 0 &&
                <div>
                    <br></br>
                    <Button variant="primary" onClick={handleAdd} >Adicionar Produto</Button>
                </div>
            }
        </div>
    )
}
interface iProps {
    local: any
    produtosDados: any[]
    produtoOptions: any[]
    unidadesDados: any[]
    unidadeOptions: any[]
}

const customStyleSelect = {
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        borderColor: "#dee2e6",
        backgroundColor: state.isDisabled ? "#E9ECEF" : "white",
    }),
    singleValue: (provided: any, state: any) => ({
        ...provided,
        color: state.isDisabled ? "black" : "black",
    }),
}
